import { Pipe, PipeTransform } from '@angular/core';
import { MainMenuLevel1ViewModel } from '@models/api.models';

@Pipe({
    name: 'sideAlignment',
    standalone: true
})
export class SideAlignmentPipe implements PipeTransform {
    transform(menuGroups?: MainMenuLevel1ViewModel[], alignment: 'left' | 'right' = 'left'): MainMenuLevel1ViewModel[] {
        if (!menuGroups) {
            return [];
        }
        return menuGroups.filter(group =>
            alignment === 'right' ? group.menuLinkRightAligned : !group.menuLinkRightAligned
        );
    }
}
